import { metricNames } from '@linearb/linjs-common';
import { yFormatter as getYFormatter } from '../../../../../CustomReport/Widgets/utils/formatters';
import { mapActivityTypeToEntityName } from '../../../../state/state.utils';
import { mapMetricNameToYAxisMetric } from '../../useFetchData/entities.utils';
import { StyledTooltip, StyledColumnItem, StyledColumn } from './Tooltip.style';
import _ from 'lodash';
const Tooltip = ({ event, contextState }) => {
  const {
    widget,
    metricName,
    filters: { activityType }
  } = contextState;
  const yFormatter = getYFormatter(widget.unitType);
  const activityName = mapActivityTypeToEntityName[activityType].single;
  const widgetName =
    metricName === metricNames.CYCLE_TIME ? 'Accounted' : widget?.name;

  const entityName = (event.point?.extraData?.name || '').replace(
    /origin\//g,
    ''
  );

  const totalCycleTime =
    metricNames.CYCLE_TIME &&
    yFormatter(
      _.get(event, ['point', 'extraData', 'stats', 'branch.cycle_time'])
    );
  const entityValue = yFormatter(event.y);

  return (
    <StyledTooltip>
      <StyledColumn flex={3}>
        <StyledColumnItem header>{activityName}</StyledColumnItem>
        <StyledColumnItem>{entityName}</StyledColumnItem>
      </StyledColumn>
      <StyledColumn flex={1}>
        <StyledColumnItem header>
          {mapMetricNameToYAxisMetric[metricName] || widgetName}
        </StyledColumnItem>
        <StyledColumnItem>{entityValue}</StyledColumnItem>
      </StyledColumn>
      {metricName === metricNames.CYCLE_TIME ? (
        <StyledColumn flex={1}>
          <StyledColumnItem header>Total</StyledColumnItem>
          <StyledColumnItem>{totalCycleTime}</StyledColumnItem>
        </StyledColumn>
      ) : (
        <></>
      )}
    </StyledTooltip>
  );
};

export default Tooltip;
